import React from 'react';
import { SquareIcon, ZoomIn } from 'lucide-react';
import * as LucideIcons from 'lucide-react';

/**
 * Компонент для выбора формы помещения и единиц измерения
 */
const RoomShapeSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  roomShapes,
  measurementUnits
}) => {
  // Динамическое получение иконок из библиотеки Lucide
  const getIconComponent = (iconName) => {
    const IconComponent = LucideIcons[iconName];
    return IconComponent ? <IconComponent className="w-5 h-5" /> : <SquareIcon className="w-5 h-5" />;
  };

  return (
    <div className="mb-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {/* Форма помещения */}
        <div>
          <label htmlFor="roomShape" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <SquareIcon className="w-4 h-4 mr-2 text-fuchsia-500" />
            Форма помещения
          </label>
          <select
            id="roomShape"
            name="roomShape"
            value={formData.roomShape}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.roomShape ? 'input-error' : ''}`}
          >
            {roomShapes.map((shape) => (
              <option key={shape.id} value={shape.id}>
                {shape.name}
              </option>
            ))}
          </select>
          {errors.roomShape && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.roomShape}
            </p>
          )}
        </div>

        {/* Единицы измерения */}
        <div>
          <label htmlFor="measurementUnit" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <ZoomIn className="w-4 h-4 mr-2 text-fuchsia-500" />
            Единицы измерения
          </label>
          <select
            id="measurementUnit"
            name="measurementUnit"
            value={formData.measurementUnit}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.measurementUnit ? 'input-error' : ''}`}
          >
            {measurementUnits.map((unit) => (
              <option key={unit.id} value={unit.id}>
                {unit.name} ({unit.acronym})
              </option>
            ))}
          </select>
          {errors.measurementUnit && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.measurementUnit}
            </p>
          )}
        </div>
      </div>

      {/* Визуальные иконки форм помещений */}
      <div className="mt-6 grid grid-cols-4 sm:grid-cols-8 gap-2">
        {roomShapes.map((shape) => (
          <button
            key={shape.id}
            type="button"
            onClick={() => handleInputChange({ target: { name: 'roomShape', value: shape.id } })}
            className={`p-3 rounded-lg border transition-colors flex flex-col items-center justify-center ${
              formData.roomShape === shape.id
                ? 'bg-fuchsia-100 border-fuchsia-300 text-fuchsia-700 dark:bg-fuchsia-900/30 dark:border-fuchsia-700 dark:text-fuchsia-300'
                : 'bg-gray-50 border-gray-200 text-gray-700 hover:bg-gray-100 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-600'
            }`}
            aria-label={shape.name}
          >
            <span className="block mb-1">{getIconComponent(shape.icon)}</span>
            <span className="text-xs text-center">{shape.name.split(' ')[0]}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RoomShapeSection;